(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-image"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-image')) {
    customElements.define(
      'announcement-image',
      class AnnouncementImage extends HTMLElement {
        connectedCallback() {
          if (this.dataset.slides === '0') return;
          this.current = 0;
          this.slides = Array.from(this.querySelectorAll('.text-slide, .image-slide'));
          this.interval = setInterval(() => {
            this.showSlide((this.current + 1) % this.slides.length);
          }, 5000);
        }
        showSlide(index) {
          this.slides.forEach((slide, i) => slide.classList.toggle('active', i === index));
          this.current = index;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-local"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('countdown-local-timer')) {
    customElements.define(
      'countdown-local-timer',
      class LocalTimer extends HTMLElement {
        connectedCallback() {
          this.hours = this.dataset.hours;
          this.minutes = this.dataset.minutes;
          this.display = this.querySelector('.countdown__display');
          this.hoursDisplay = this.querySelector('.hours-display');
          this.minutesDisplay = this.querySelector('.minutes-display');
          this.secondsDisplay = this.querySelector('.seconds-display');

          this.completeMessage = this.dataset.completeMessage;

          if (!this.dataset.id) {
            console.warn('<countdown-local-timer> Missing required data-id attribute.');
            return;
          }
          this.storeKey = `local-timer-offset-${this.dataset.id}`;

          this.offset = this.#getStored();
          this.totalSeconds = this.hours * 3600 + this.minutes * 60;

          this.init();
        }

        init() {
          setInterval(() => {
            if (!this.timerComplete) {
              this.#calculate();
            }
          }, 1000);

          this.#calculate();
          this.display.style.visibility = 'visible';
          this.display.style.opacity = '1';
        }

        #calculate() {
          const now = Date.now();
          const elapsed = Math.floor((now - this.offset) / 1000);

          let remaining = this.totalSeconds - elapsed;

          if (remaining <= 0) {
            remaining = 0;
            this.timerComplete = true;
            clearInterval(this.interval);
            localStorage.setItem('X25vX2dpZnQ=', 'true');
            if (this.completeMessage) {
              this.innerHTML = `<div style="font-weight:bold;">${this.completeMessage}</div>`;
            }
          }

          const hours = Math.floor(remaining / 3600);
          const minutes = Math.floor((remaining % 3600) / 60);
          const seconds = remaining % 60;

          this.hoursDisplay.textContent = this.#pad(hours);
          this.minutesDisplay.textContent = this.#pad(minutes);
          this.secondsDisplay.textContent = this.#pad(seconds);
        }

        #pad(num) {
          return String(num).padStart(2, '0');
        }

        #getStored() {
          let stored = JSON.parse(localStorage.getItem(this.storeKey));
          if (stored && stored.expireTime && stored.expireTime <= Date.now()) {
            localStorage.removeItem('X25vX2dpZnQ=');
            localStorage.removeItem(this.storeKey);
            stored = null;
          }

          if (!stored) {
            let value = Date.now();
            if (localStorage.hasOwnProperty('local-timer-offset')) {
              value = parseInt(localStorage.getItem('local-timer-offset'), 10);
              localStorage.removeItem('local-timer-offset');
            }
            stored = {
              value: value,
              expireTime: Date.now() + 7 * 24 * 60 * 60 * 1000,
            };
            localStorage.setItem(this.storeKey, JSON.stringify(stored));
          }
          return parseInt(stored.value, 10);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dealers-form"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('dealers-form')) {
      customElements.define(
        'dealers-form',
        class DealersForm extends HTMLElement {
          constructor() {
            super();
            this.onSubmit = this.onSubmit.bind(this);
          }
          connectedCallback() {
            this.form = this.querySelector('form');
            this.submitter = this.form.querySelector('.btn[type=submit]');
            this.formError = this.querySelector('.form-error');
            this.successNote = this.querySelector('.note--success');
            this.form.addEventListener('submit', this.onSubmit);
          }

          disconnectedCallback() {
            this.form.removeEventListener('submit', this.onSubmit);
          }

          async onSubmit(evt) {
            evt?.preventDefault();
            if (this.status === 'loading') return;

            this.formError.classList.add('hide');
            this.successNote.classList.add('hide');
            this.form.querySelectorAll('.input-full.error').forEach((i) => {
              i.classList.remove('error');
              i.removeAttribute('aria-invalid');
            });

            try {
              this.status = 'loading';
              const formData = new FormData(this.form);
              this.submitter.classList.add('btn--loading');
              const response = await fetch(this.form.action, {
                method: this.form.method,
                body: formData,
              });
              if (response.status === 200 || response.status === 400) {
                const json = await response.json();
                if (response.status === 200) {
                  this.successNote.classList.remove('hide');
                  this.form.reset();
                  this.successNote.focus();
                } else {
                  const errors = json?.error?.fieldErrors || [];
                  let errMsg = '';
                  for (const [key, value] of Object.entries(errors)) {
                    const input = this.form.elements[key];
                    input.classList.add('error');
                    input.setAttribute('aria-invalid', 'true');
                    errMsg += `<li>${value[value.length - 1]}</li>`;
                  }
                  this.displayError(`<ul>${errMsg}</ul>`);
                }
              } else {
                throw new Error(response.statusText);
              }
            } catch (err) {
              console.log(err);
              this.displayError(`Error submitting form, please try again`);
            } finally {
              this.status = 'idle';
              this.submitter.classList.remove('btn--loading');
            }
          }

          displayError(message) {
            this.formError.innerHTML = message;
            this.formError.classList.remove('hide');
            this.formError.focus();
          }
        }
      );
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-scroll"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('multicolumn-scroll')) {
    customElements.define(
      'multicolumn-scroll',
      class MulticolumnScroll extends HTMLElement {
        config = {
          pageDots: true,
          prevNextButtons: false,
          adaptiveHeight: false,
          autoPlay: false,
          childVertical: false,
          dragThreshold: 7,
          fade: false,
          friction: 0.8,
          initialIndex: 0,
          pauseAutoPlayOnHover: false,
          righToLeft: false,
          selectedAttraction: 0.14,
          setGallerySize: true,
          wrapAround: true,
          imagesLoaded: true,
        };

        connectedCallback() {
          if (this.dataset.blocks === '1') return;
          this.namespace = this.dataset.sectionId;
          this.scrollContainer = this.querySelector('.multicolumn-container');
          this.scrollMainImage = this.querySelector('.column-main_image');
          this.scrollInstance = null;

          if (theme.utils) {
            this.addListener();
            this.toggleColumns();
          } else {
            document.addEventListener('page:loaded', () => {
              this.addListener();
              this.toggleColumns();
            });
          }
        }

        disconnectedCallback() {
          window.off('resize.' + this.namespace);
        }

        addListener() {
          window.on('resize.' + this.namespace, theme.utils.debounce(300, this.toggleColumns.bind(this)));
        }

        toggleColumns() {
          if (window.matchMedia('screen and (max-width: 768px)').matches) {
            if (!this.scrollInstance) {
              this.scrollInstance = new Flickity(this.scrollContainer, this.config);
              if (this.scrollMainImage && !this.scrollMainImage.complete) {
                this.imageLoadResizeHandler = this.resizeOnImageLoad.bind(this);
                this.scrollMainImage.addEventListener('load', this.imageLoadResizeHandler);
              }
            } else {
              this.scrollInstance.resize();
            }
          } else {
            if (this.scrollInstance) {
              this.scrollInstance.destroy();
              this.scrollInstance = null;
            }
          }
        }

        resizeOnImageLoad() {
          if (this.scrollInstance) {
            this.scrollInstance.resize();
            this.scrollMainImage.removeEventListener('load', this.imageLoadResizeHandler);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-comparison')) {
    customElements.define(
      'product-comparison',
      class ProductComparison extends HTMLElement {
        constructor() {
          super();
          this.init = this.init.bind(this);
        }

        connectedCallback() {
          if (theme.Modals) {
            this.init();
          } else {
            document.addEventListener(`page:loaded`, this.init);
          }
        }
        init() {
          new theme.Modals(
            `ProductComparisonModal-${this.dataset.sectionId}`,
            `pcomparison-modal-${this.dataset.sectionId}`
          );
          document.removeEventListener(`page:loaded`, this.init);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scrolling-text-pause')) {
    customElements.define(
      'scrolling-text-pause',
      class ScrollingTextPause extends HTMLElement {
        connectedCallback() {
          this.querySelector('button')?.addEventListener('click', (evt) => {
            const paused = this.closest('.scrolling-text').classList.toggle('is-paused');
            evt.currentTarget.setAttribute('aria-label', paused ? 'Play scrolling text' : 'Pause scrolling text');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-sizing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('simple-sizing')) {
    customElements.define(
      'simple-sizing',
      class SimpleSizing extends HTMLElement {
        connectedCallback() {
          const optionsEl = this.querySelector('[data-size-options]');
          if (!optionsEl) return;

          this.sizeOptions = JSON.parse(optionsEl.textContent || '[]');
          this.sizeSelect = this.querySelector('[data-size-select]');
          this.circumferenceSelect = this.querySelector('[data-circumference-select]');
          this.circumferenceOptions = Array.from(this.circumferenceSelect.options).filter((opt) => opt.value !== '');

          this.lengthLabels = Array.from(this.querySelectorAll('[data-length]'));
          this.widthLabels = Array.from(this.querySelectorAll('[data-width]'));
          this.cells = Array.from(this.querySelectorAll('[data-cell]'));

          this.recContainer = this.querySelector('[data-rec-container]');
          this.recLengths = this.querySelectorAll('[data-rec-length]');
          this.recWidths = this.querySelectorAll('[data-rec-width]');
          this.recLink = this.querySelector('[data-rec-link]');
          this.unavailable = this.querySelector('[data-unavailable]');
          this.customOnly = this.querySelector('[data-custom-only]');
          this.customOnlyWidths = (this.dataset.customOnlyWidths || '')
            .split(',')
            .map((w) => w.trim().toUpperCase())
            .filter(Boolean);
          this.notAvailable = this.querySelector('[data-not-available]');
          this.noCustomLengths = (this.dataset.noCustomLengths || '')
            .split(',')
            .filter((l) => l.trim() !== '')
            .map(Number);

          this.size = Number(this.sizeSelect.value);
          this.widthIndex = this.circumferenceSelect.value === '' ? null : Number(this.circumferenceSelect.value);

          this.sizeSelect.addEventListener('change', () => this.setSize(Number(this.sizeSelect.value)));
          this.circumferenceSelect.addEventListener('change', () => {
            this.setWidth(this.circumferenceSelect.value === '' ? null : Number(this.circumferenceSelect.value));
          });
          this.querySelector('table').addEventListener('click', (evt) => this.onTableClick(evt));

          // Lengths without a matching standard size can't be selected
          this.lengthLabels.forEach((label) => {
            if (!this.getSizeOption(Number(label.dataset.length))) {
              label.classList.add('is-disabled');
              label.querySelector('button')?.setAttribute('disabled', '');
            }
          });

          this.render();
        }

        getSizeOption(size = this.size) {
          return this.sizeOptions.find((opt) => Number(opt.size) === size);
        }

        getLengthIndex(length) {
          return this.lengthLabels.findIndex((label) => Number(label.dataset.length) === length);
        }

        onTableClick(evt) {
          const lengthLabel = evt.target.closest('[data-length]');
          if (lengthLabel) {
            const size = Number(lengthLabel.dataset.length);
            if (this.getSizeOption(size)) {
              this.sizeSelect.value = String(size);
              this.setSize(size);
            }
            return;
          }

          const cell = evt.target.closest('[data-cell]');
          if (cell && Number(cell.dataset.lengthIndex) === this.recLengthIndex) {
            this.setWidth(Number(cell.dataset.widthIndex));
          }
        }

        setSize(size) {
          // Keep the same circumference measurement selected, which may land on a different width
          const prevOption = this.getSizeOption();
          const prevMeasurement = this.widthIndex !== null ? prevOption?.measurements[this.widthIndex] : null;

          this.size = size;
          const sizeOption = this.getSizeOption();
          this.circumferenceOptions.forEach((opt, idx) => {
            opt.textContent = sizeOption?.measurements[idx] ?? '';
          });

          if (prevMeasurement != null) {
            const idx = sizeOption ? sizeOption.measurements.indexOf(prevMeasurement) : -1;
            this.widthIndex = idx >= 0 ? idx : null;
          }

          this.render();
        }

        setWidth(widthIndex) {
          this.widthIndex = widthIndex;
          this.render();
        }

        setNote(el, text) {
          el.querySelector('[data-sr-note]')?.remove();
          if (!text) return;
          const note = document.createElement('span');
          note.className = 'visually-hidden';
          note.dataset.srNote = '';
          note.textContent = `, ${text}`;
          el.append(note);
        }

        render() {
          const recLength = this.size - 1;
          this.recLengthIndex = this.getLengthIndex(recLength);
          const isAvailable = this.recLengthIndex >= 0 && !!this.getSizeOption();
          const widthIndex = isAvailable ? this.widthIndex : null;

          // Highlights also get screen reader notes so they aren't conveyed by color alone
          this.lengthLabels.forEach((label, idx) => {
            const isRecommended = idx === this.recLengthIndex;
            const isSelected = !isRecommended && Number(label.dataset.length) === this.size;
            label.classList.toggle('is-recommended', isRecommended);
            label.classList.toggle('is-selected', isSelected);
            this.setNote(
              label.querySelector('button') || label,
              isRecommended ? 'recommended length' : isSelected ? 'your standard size' : ''
            );
          });

          this.widthLabels.forEach((label, idx) => {
            const isRecommended = idx === widthIndex;
            label.classList.toggle('is-recommended', isRecommended);
            this.setNote(label, isRecommended ? 'recommended width' : '');
          });

          this.cells.forEach((cell) => {
            const inColumn = Number(cell.dataset.lengthIndex) === this.recLengthIndex;
            const isSelected = inColumn && Number(cell.dataset.widthIndex) === widthIndex;
            cell.classList.toggle('is-active-column', inColumn);
            cell.classList.toggle('is-selected', isSelected);
            if (isSelected) {
              cell.setAttribute('aria-current', 'true');
            } else {
              cell.removeAttribute('aria-current');
            }
            this.setNote(cell, isSelected ? 'selected circumference' : '');
          });

          this.circumferenceSelect.value = widthIndex === null ? '' : String(widthIndex);

          const recWidth = widthIndex !== null ? this.widthLabels[widthIndex]?.dataset.width ?? '' : '';
          this.recLengths.forEach((el) => (el.textContent = isAvailable ? recLength : ''));
          this.recWidths.forEach((el) => (el.textContent = recWidth ? `\u00A0/\u00A0${recWidth}` : ''));

          // Some widths aren't stocked, so there's nothing to shop on the stock lookup page
          const isCustomOnly =
            isAvailable && !!recWidth && this.customOnlyWidths.includes(recWidth.trim().toUpperCase());

          this.recContainer.hidden = !isAvailable;
          this.unavailable.hidden = isAvailable;
          // Custom boots aren't made in some lengths, so a custom-only width there has no products at all
          const isNotAvailable = isCustomOnly && this.noCustomLengths.includes(recLength);

          this.customOnly.hidden = !isCustomOnly || isNotAvailable;
          this.notAvailable.hidden = !isNotAvailable;
          this.recLink.hidden = isCustomOnly;

          if (isAvailable && recWidth && !isCustomOnly) {
            const url = new URL(this.dataset.stockLookupUrl, window.location.origin);
            url.searchParams.set('length', recLength);
            url.searchParams.set('width', recWidth);
            this.recLink.href = url.pathname + url.search;
            this.recLink.classList.remove('disabled');
            this.recLink.removeAttribute('role');
            this.recLink.removeAttribute('aria-disabled');
          } else {
            this.recLink.removeAttribute('href');
            this.recLink.classList.add('disabled');
            this.recLink.setAttribute('role', 'link');
            this.recLink.setAttribute('aria-disabled', 'true');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-column"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonials-column')) {
    customElements.define(
      'testimonials-column',
      class TestimonialsColumn extends HTMLElement {
        connectedCallback() {
          if (!this.$template) this.$template = this.querySelector('template');
          this.count = parseInt(this.dataset.count, 8) || 8;
          this.loadReviews();
        }

        async loadReviews() {
          const response = await fetch(
            `https://api.okendo.io/v1/stores/b22f4a33-c466-49da-b5af-80fccf1ba03e/reviews?limit=${this.count}&orderBy=date%20desc`
          );
          const json = await response.json();
          const reviewNode = this.$template.content.querySelector('.review-block');
          json.reviews.forEach((review) => {
            const blockElement = reviewNode.cloneNode(true);
            blockElement.querySelector('.testimonial-stars').textContent = '★'.repeat(review.rating);
            blockElement.querySelector('.review-title').textContent = review.title;
            blockElement.querySelector('.review-text').textContent = review.body;
            blockElement.querySelector('.reviewer .name').textContent = review.reviewer.displayName;
            this.appendChild(blockElement);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
